const buildPersonDetails = (t, person, personKey, dropdowns = {}) => {

  return [
    {
      title: t('general.lastName'),
      value: person.lastName || "",
      name: `${personKey}.lastName`,
      required: true
    },
    {
      title: t('general.namePrefixes'),
      value: person.middleName || "",
      name: `${personKey}.middleName`,
      type: 'select',
      options: dropdowns.middleNames || []
    },
    {
      title: t('general.initials'),
      value: person.initials || "",
      name: `${personKey}.initials`
    },
    {
      title: t('general.firstName'),
      value: person.firstName || "",
      name: `${personKey}.firstName`
    },
    {
      title: t('general.gender'),
      value: person.gender || "",
      name: `${personKey}.gender`,
      type: 'select',
      required: true,
      options: dropdowns.genders || []
    },
    {
      title: t('user.profile.general.titleFor'),
      value: person.titleFor || "",
      name: `${personKey}.titleFor`,
      type: 'select',
      options: dropdowns.titleFor || []
    },
    {
      title: t('user.profile.general.titleBehind'),
      value: person.titleBehind || "",
      name: `${personKey}.titleBehind`,
      type: 'select',
      options: dropdowns.titleBehind || []
    }
  ];
};

export const getPerson1Details = (t, data, dropdowns = {}) => {
  const person1 = data.p1 || {};
  return buildPersonDetails(t, person1, 'p1', dropdowns);
};


export const getPerson2Details = (t, data, dropdowns = {}) => {
  const person2 = data.p2 || {};
  return buildPersonDetails(t, person2, 'p2', dropdowns);
};

export const getOrganizationInfo = (t, data, dropdowns = {}) => {
  const org = data?.org || {};

  return [
    { title: t('general.searchName'), value: org.searchName || "", name: "org.searchName" },
    { title: t('general.namePrefixes'), value: org?.middleName || "", name: "org.middleName", type: 'select', options: dropdowns.middleNames || [] },
    { title: t('general.initials'), value: org.initials || "", name: "org.initials" },
    { title: t('general.name'), value: org.name || "", name: "org.name" },
    { title: t('general.telephone'), value: org.telephone || "", name: "org.telephone" },
    { title: t('general.email'), value: org.email || "", name: "org.email" },
    { title: t('general.website'), value: org.website || "", name: "org.website" }
  ];
};

export const getRelationDetails = (t, data, dropdowns = {}) => {
  const org = data?.org || {};
  console.log(dropdowns);

  return [
    { title: t('general.lastName'), value: org.lastName || "", name: "org.lastName" },
    { title: t('general.namePrefixes'), value: org?.middleName || "", name: "org.middleName", type: 'select', options: dropdowns.middleNames || [] },
    { title: t('general.initials'), value: org.initials || "", name: "org.initials" },
    { title: t('general.firstName'), value: org.relationName || "", name: "org.relationName" },
    { title: t('general.function'), value: org.relationFunctionName || "", name: "org.relationFunctionName" },
    { title: t('general.department'), value: org.relationDepartment || "", name: "org.relationDepartment" },
    { title: t('buyersGuide.businessEmail'), value: org.relationEmail || "", name: "org.relationEmail" },
    { title: t('general.telephone'), value: org.relationTelephone || "", name: "org.relationTelephone" },
    { title: t('buyersGuide.mobile'), value: org.relationMobile || "", name: "org.relationMobile" },
  ];
};


export const getGeneralBuyerDetails = (t, data, dropdowns = {}) => {
  const general = data?.general || {};
   const clientType =
    data?.type === 1
      ? "ORGANIZATION"
      : "PRIVATE";
  return [
    {
      title: t('general.general'),
      details: [
        {
          title: t('general.type'),
          value: clientType,
          name: 'general.type',
          type: 'select',
          options: dropdowns.clientTypes || []
        },
        {
          title: t('general.status'),
          value: general.status || 'BUYER',
          name: 'general.status',
          type: 'select',
          options: dropdowns.statuses || []
        },
        {
          title: 'language',
          value: general.language || '',
          name: 'general.language',
          type: 'select',
          options: dropdowns.languages || []
        },
        {
          title: 'ReleaseData',
          value: Boolean(general.releasePermission),
          name: 'general.releasePermission',
          type: 'checkbox'
        },
        {
          title: 'AllAddresses',
          value: Boolean(general.sendEmailAll),
          name: 'general.sendEmailAll',
          type: 'checkbox'
        }
      ]

    },
    {
      title: t('general.email'),
      details: [

        {
          title: 'Permission to release data to third parties',
          value: general.status || 'BUYER',
          name: 'Permission to release data to third parties',
          type: 'checkbox',
        },
        {
          title: 'Send email to all known email addresses',
          value: general.language || '',
          name: 'Send email to all known email addresses',
          type: 'checkbox',
        },
      ]
    },



  ];
};


export const getPerson1CommunicationDetails = (t, data) => {
  const p1 = data?.p1 || {};

  return [
    { title: t('buyersGuide.buyersInfo.phonePrivate'), value: p1.telephonePrivate || "", name: "p1.telephonePrivate" },
    { title: t('buyersGuide.buyersInfo.phoneWork'), value: p1.telephoneWork || "", name: "p1.telephoneWork" },
    { title: t('buyersGuide.mobile'), value: p1.mobile || "", name: "p1.mobile" },
    { title: t('repairRequest.receivedvia.6'), value: p1.emailWork || "", name: "p1.emailWork" },
    { title: t('general.emailPrivate'), value: p1.emailPrivate || "", name: "p1.emailPrivate" },
    { title: t('buyersGuide.buyersInfo.emailWork'), value: p1.emailWork || "", name: "p1.emailWork" },
  ];
};

export const getPerson2CommunicationDetails = (t, data) => {
  const p2 = data?.p2 || {};

  return [
    { title: t('buyersGuide.buyersInfo.phonePrivate'), value: p2.telephonePrivate || "", name: "p2.telephonePrivate" },
    { title: t('buyersGuide.buyersInfo.phoneWork'), value: p2.telephoneWork || "", name: "p2.telephoneWork" },
    { title: t('buyersGuide.mobile'), value: p2.mobile || "", name: "p2.mobile" },
    { title: t('repairRequest.receivedvia.6'), value: p2.emailWork || "", name: "p2.emailWork" },
    { title: t('general.emailPrivate'), value: p2.emailPrivate || "", name: "p2.emailPrivate" },
    { title: t('buyersGuide.buyersInfo.emailWork'), value: p2.emailWork || "", name: "p2.emailWork" },
  ];
};

export const getCorrespondenceAddressDetails = (t, data, dropdowns = {}) => {
  const address = data?.correspondenceAddress || {};

  return [
    {
      title: t('general.address'),
      value: address.addressId || "",
      name: 'correspondence.addressId',
      type: "address-autocomplete",
    },
    {
      title: t('buyersGuide.buyerActions.add.addressSolution'),
      value: address.salutation || "",
      name: 'correspondence.salutation',
      type: 'select',
      options: dropdowns.addressSalutations || []
    },
    {
      title: t('buyersGuide.buyerActions.add.nameInTwoLines'),
      value: Boolean(address.nameInTwoLines),
      name: 'correspondence.nameInTwoLines',
      type: 'checkbox'
    }
  ];
};

export const getRentersInformation = (t, data, dropdowns = {}) => {
  console.log({ dropdowns });

  if (!data) return [];

  // Buyer
  if (data.type === 0) {

    const result = [{
      title: `${t('general.person')} 1`,
      details: getPerson1Details(t, data, dropdowns),
    }];

    if (data.p2)
      result.push({
        title: `${t('general.person')} 2`,
        details: getPerson2Details(t, data, dropdowns),
      });

    return result;
  }

  return [
    {
      title: t('general.organisation'),
      details: getOrganizationInfo(t, data, dropdowns)
    },
    {
      title: t('workOrders.relation'),
      details: getRelationDetails(t, data, dropdowns)
    }
  ];
};

export const getCommunicationInfo = (t, data) => {

  if (!data) return [];

  // Buyer
  if (data.type === 0) {

    const result = [{
      title: `${t('buyersGuide.buyerActions.add.communicationPerson')} 1`,
      details: getPerson1CommunicationDetails(t, data),
    }];

    if (data.p2)
      result.push({
        title: `${t('buyersGuide.buyerActions.add.communicationPerson')} 2`,
        details: getPerson2CommunicationDetails(t, data),
      });

    return result;                                                                       
  }

  // return [
  //   {
  //     title: t('general.organisation'),
  //     details: getOrganizationInfo(t, data,dropdowns)
  //   },
  //   {
  //     title: t('workOrders.relation'),
  //     details: getRelationDetails(t, data,dropdowns)
  //   }
  // ];
};